<template>
  <div>
    <div class="tab__sub-header">{{ title }}</div>
    <div class="kpi__table-container">
      <table class="kpi-table">
        <tr class="kpi-table__header">
          <th colspan="2">Key Performance Indicators</th>
          <th v-for="month in monthAbbrevs">{{ month }}</th>
          <th colspan="3">YTD</th>
        </tr>
        <tr class="kpi-table__header">
          <th colspan="2">Description</th>
          <th v-for="months in monthAbbrevs">Actual</th>
          <th>BMK</th>
          <th>Actual</th>
          <th>Variance</th>
        </tr>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metrics" :index="index" :key="`row-high-level-${index}`" :metric="metric"></component>
      </table>
    </div>
    <div class="legend"><span class="legend__key kpi-performance-table__month--selected"></span> = Selected Month</div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import TableRowBase from './table-rows/TableRowBase.vue';
  import TableRowTestsSubtotal from './table-rows/TableRowTestsSubtotal.vue';
  import TableRowVialsTotalNewPatients from './table-rows/TableRowVialsTotalNewPatients.vue';
  import TableRowVialsTotal from './table-rows/TableRowVialsTotal.vue';
  import TableRowNewPatientsTotal from './table-rows/TableRowNewPatientsTotal.vue';
  import TableRowActivePatientsSubtotal from './table-rows/TableRowActivePatientsSubtotal.vue';
  import TableRowNumTestsPerPhysician from './table-rows/TableRowNumTestsPerPhysician.vue';
  import TableRowNumTestsPerTech from './table-rows/TableRowNumTestsPerTech.vue';
  import TableRowTestedToTreatmentConversionRate from './table-rows/TableRowTestedToTreatmentConversionRate.vue';
  import TableRowPercentNewPatientsOnScit from './table-rows/TableRowPercentNewPatientsOnScit.vue';
  import TableRowPercentNewPatientsOnSlit from './table-rows/TableRowPercentNewPatientsOnSlit.vue';
  import TableRowNumInjectionsPerTech from './table-rows/TableRowNumInjectionsPerTech.vue';
  import TableRowNumVialsMixedPerTech from './table-rows/TableRowNumVialsMixedPerTech.vue';
  import TableRowNumVialsMixedPerMixingLocation from './table-rows/TableRowNumVialsMixedPerMixingLocation.vue';
  import TableRowNumErrorsPerTech from './table-rows/TableRowNumErrorsPerTech.vue';

  export default {
    name: 'TrackingSheetTable',
    props: ['title', 'metrics'],
    components: {
      TableRowBase,
      TableRowTestsSubtotal,
      TableRowVialsTotalNewPatients,
      TableRowVialsTotal,
      TableRowNewPatientsTotal,
      TableRowActivePatientsSubtotal,
      TableRowNumTestsPerPhysician,
      TableRowNumTestsPerTech,
      TableRowTestedToTreatmentConversionRate,
      TableRowPercentNewPatientsOnScit,
      TableRowPercentNewPatientsOnSlit,
      TableRowNumInjectionsPerTech,
      TableRowNumVialsMixedPerTech,
      TableRowNumVialsMixedPerMixingLocation,
      TableRowNumErrorsPerTech,
    },
    computed: {
      ...mapGetters('allergyKpis', ['monthAbbrevs', 'ytdCustomCalculationFields']),
      slug() {
        return lodash.kebabCase(this.title);
      },
    },
    methods: {
      getComponentName(field) {
        if (this.ytdCustomCalculationFields.includes(field)) {
          return `TableRow${lodash.chain(field).camelCase().upperFirst().value()}`;
        }
        return 'TableRowBase';
      },
    },
  };
</script>

